<template>
  <div class="content">
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Manage Banner</h6>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--6">
      <modal
        :show.sync="modals.showModal"
        body-classes="p-0"
        modal-classes="modal-dialog-centered modal-md"
      >
        <card
          type="secondary"
          shadow
          header-classes="bg-white pb-5"
          body-classes="px-lg-5 py-lg-5"
          class="border-0"
        >
          <template>
            <form role="form" class="mb--4">
              <div class="form-group row mb--2">
                <label class="col-md-4 col-form-label form-control-label">
                  Image
                </label>

                <div class="col-md-8">
                  <img
                    v-if="loading == false"
                    :src="cover"
                    @click="$refs.file.click()"
                    style="width: 100px; height: 100px; margin-bottom: 1rem"
                    alt="imgAdd"
                  />

                  <i
                    v-if="myObj.imageURL"
                    class="fa fa-trash fa-1x cursor-pointer"
                    @click="deleteCover()"
                    style="margin-left: 10px"
                  ></i>

                  <div
                    v-if="loading == true"
                    class="text-center"
                    style="width: 100px; height: 100px; margin-bottom: 1rem"
                  >
                    <i
                      class="fas fa-circle-notch fa-spin fa-2x"
                      style="color: grey; margin-top: 15px"
                    ></i>
                  </div>

                  <input
                    type="file"
                    id="file"
                    ref="file"
                    @change="selectFile"
                    accept="image/*"
                    hidden
                  />
                </div>
              </div>

              <div class="form-group row mb--2">
                <label class="col-md-4 col-form-label form-control-label">
                  Title
                </label>

                <div class="col-md-8">
                  <base-input
                    placeholder="Banner Title"
                    v-model="myObj.title"
                  ></base-input>
                </div>
              </div>

              <div class="form-group row mb--2">
                <label class="col-md-4 col-form-label form-control-label">
                  URL
                </label>

                <div class="col-md-8">
                  <base-input
                    placeholder="Button url"
                    v-model="myObj.buttonURL"
                  ></base-input>
                </div>
              </div>

              <div class="form-group row mb--2">
                <label class="col-md-4 col-form-label form-control-label">
                  Banner Type
                </label>

                <div class="col-md-8">
                  <el-select
                    class="select-primary pagination-select"
                    v-model="myObj.bannerID"
                    placeholder="Select type"
                  >
                    <el-option
                      class="select-primary pull-right"
                      v-for="item in typeOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>

              <div class="mt-4">
                <base-button
                  :disabled="saving"
                  @click="addCategory()"
                  type="primary"
                  class="col"
                >
                  <i v-bind:class="sign"></i>
                  {{ optionName }}
                </base-button>
              </div>
            </form>
          </template>
        </card>
      </modal>

      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header"> </template>

          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                hidden
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary pull-right"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>

              <div class="col-md-2">
                <base-button
                  :disabled="saving"
                  @click="ShowModal()"
                  type="primary"
                  class="col"
                >
                  <!-- <i v-bind:class="sign"></i> -->
                  Add Banner
                </base-button>
              </div>

              <div class="col-md-10">
                <base-input
                  placeholder="Search banner"
                  v-model="searchQuery"
                ></base-input>

                <!-- v-model="searchInput"
                  v-on:keyup.enter="searchDataa" -->
              </div>

              <!-- 
              <base-input
                v-model="searchQuery"
                prepend-icon="fas fa-search"
                placeholder="Search..."
              >


              </base-input> -->
            </div>

            <el-table
              :data="queriedData"
              row-key="banner_id"
              header-row-class-name="thead-light"
              @sort-change="sortChange"
              @selection-change="selectionChange"
              style="margin-top: 20px"
            >
              <el-table-column min-width="120px" label="Image">
                <div slot-scope="{ row }">
                  <img :src="row.imageURL" style="width: 100%" />
                </div>
              </el-table-column>

              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                v-bind="column"
              >
              </el-table-column>

              <el-table-column min-width="180px" align="right" label="Options">
                <div slot-scope="{ $index, row }" class="d-flex">
                  <base-button
                    @click="editRecord($index, row)"
                    class="like btn-link"
                    type="primary"
                    size="sm"
                    icon
                  >
                    <i class="text-white far fa-edit"></i>
                  </base-button>

                  <base-button
                    @click="handleDelete(row)"
                    class="like btn-link"
                    type="danger"
                    size="sm"
                    icon
                  >
                    <i class="text-white fas fa-trash"></i>
                  </base-button>
                </div>
              </el-table-column>
            </el-table>
          </div>

          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
                <span v-if="selectedRows.length">
                  &nbsp; &nbsp; {{ selectedRows.length }} rows selected
                </span>
              </p>
            </div>

            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../Tables/PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import users from "../Tables/users2";
import axios from "axios";
import qs from "qs";
import Vue from "vue";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";
import Multiselect from "vue-multiselect";

export default {
  mixins: [clientPaginationMixin],
  components: {
    Multiselect,
    BasePagination,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    flatPicker,
  },
  created() {
    this.Authenticator();
    this.LoadData();
  },
  //   mounted() {
  //     this.Authenticator();
  //   },

  data() {
    return {
      typeOptions: ["Banner 1", "Banner 2", "Banner 3"],
      cover: "/img/Plus.jpg",
      files: [],
      selectedFiles: undefined,
      loading: false,
      searchInput: "",
      myObj: {
        banner_id: 0,
        buttonURL: "",
        imageURL: "",
        bannerID: "",
        title: "",
      },
      tags: [
        { id: "Just Dropped", name: "Just Dropped" },
        { id: "Most Popular", name: "Most Popular" },
        { id: "Favorites", name: "Favorites" },
        { id: "Air Jordon", name: "Air Jordon" },
        { id: "Adidas Yeezy", name: "Adidas Yeezy" },
        { id: "Dunks", name: "Dunks" },
        { id: "Jordon 1", name: "Jordon 1" },
        { id: "Travis Scot", name: "Travis Scot" },
        { id: "Off White", name: "Off White" },
        { id: "Men", name: "Men" },
        { id: "Women", name: "Woman" },
        { id: "Featured", name: "Featured" },
        { id: "Popular", name: "Popular" },
        { id: "New", name: "New" },
      ],
      propsToSearch: ["buttonURL"],
      tableColumns: [
        {
          prop: "title",
          label: "Title",
          minWidth: 80,
          sortable: true,
        },
        {
          prop: "buttonURL",
          label: "url",
          minWidth: 200,
          sortable: true,
        },
      ],
      file: "",
      tableData: [],
      searchData: [],
      collectionData: [],
      collectionOptions: [],
      selectedTags: [],
      selectedRows: [],
      moreShoesImages: [],
      modals: {
        showModal: false,
      },
      optionName: "Add Banner",
      saving: false,
      name: "",
      prefixname: "",
      prefixError: false,
      nameError: false,
      sign: "",
      err: {
        nameerr: false,
        contacterr: false,
        mobileerr: false,
        purposevsterr: false,
        dateerr: false,
      },
      currentDate: moment().format("YYYY-MM-DD"),
      eIndex: 0,
    };
  },

  methods: {
    Authenticator() {
      ////console.log(this.$store.state.myUser.email , this.$store.state.myUser.password );
      if (
        this.$store.state.myUser.email == null ||
        this.$store.state.myUser.password == null ||
        this.$store.state.myUser.email == "" ||
        this.$store.state.myUser.password == ""
      ) {
        //console.log("Hi If");
        this.$store.state.myUser.email = "";
        this.$store.state.myUser.password = "";

        return this.$router.push("/login");
      } else if (
        this.$store.state.isVetter == null ||
        this.$store.state.isVetter
      ) {
        return this.$router.push("/login");
      }
    },
    deleteMoreImages(more_image_id, shoe_id) {
      swal({
        title: "Are you sure?",
        text: "You want to delete this image?",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          axios
            .delete(this.$store.state.domain + "/shoesImages/" + more_image_id)
            .then((res) => {
              //Load more images
              this.LoadImages(shoe_id);
            })
            .catch((err) => {
              console.error("img", err);
            });
        }
      });
    },
    searchDataa() {
      console.log("Searching:", this.searchInput);
      if (this.searchInput.length > 0) {
        var url =
          this.$store.state.domain + "/shoes/getByName/" + this.searchInput;
        axios
          .get(url)
          .then((response) => {
            if (response.data.status === "error") {
              //this.$notify({verticalalign: 'bottom', horizontalalign: 'center', message: 'Request Error! <br />' + response.data.status.data, type: 'danger', icon: 'fa fa-ban',timeout: 0 });
            } else {
              this.tableData = [];
              response.data.forEach((element) => {
                if (element.release_date !== null)
                  element.release_date = moment(element.release_date).format(
                    "DD MMM YYYY, ddd"
                  );
              });
              this.tableData = response.data;
            }
          })
          .catch(function (error) {
            //console.log(error);
          });
      } else {
        this.LoadData();
      }
    },

    LoadData() {
      var url = this.$store.state.domain + "/banners";
      axios
        .get(url)
        .then((response) => {
          if (response.data.status === "error") {
            //this.$notify({verticalalign: 'bottom', horizontalalign: 'center', message: 'Request Error! <br />' + response.data.status.data, type: 'danger', icon: 'fa fa-ban',timeout: 0 });
          } else {
            console.log(response.data);
            let data = [];
            response.data.forEach((el) => {
              el.forEach((ch) => {
                data.push(ch);
              });
            });
            console.log(data);
            this.tableData = data;
          }
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    LoadImages(shoeID) {
      var url = this.$store.state.domain + "/shoesImages/" + shoeID;
      axios
        .get(url)
        .then((response) => {
          if (response.data.status === "error") {
            //console.log(response.data.status);
          } else {
            this.moreShoesImages = response.data;
            //console.log(this.moreShoesImages);
          }
        })
        .catch(function (error) {
          //console.log(error);
        });
    },
    ShowModal() {
      this.collectionData = [];
      this.optionName = "Add Banner";
      this.sign = "fas fa-plus";
      this.myObj.banner_id = 0;
      this.myObj.buttonURL = "";
      this.myObj.imageURL = "";
      this.myObj.bannerID = "";
      this.myObj.title = "";
      this.cover = "/img/Plus.jpg";
      this.modals.showModal = true;
    },
    deleteCover() {
      this.myObj.imageURL = "";
      this.cover = "/img/Plus.jpg";
      this.$refs.file.value = null;
    },
    selectFile() {
      this.file = this.$refs.file.files[0];

      //Upload cover
      if (this.file) {
        this.loading = true;
        let formData = new FormData();
        formData.append("file", this.file);
        //console.log(this.file);
        axios
          .post("https://uploadert.appicksolutions.com", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((e) => {
            //console.log(e.data);
            // this.file = undefined;
            var fn = e.data.myresp[0].path;

            this.myObj.imageURL = fn;
            this.cover = fn;
            this.loading = false;
            //console.log(this.myObj.cover_image);
            // this.UpdateCover();
          });
      }
    },
    selectMoreFile() {
      this.spin = "fas fa-circle-notch fa-spin";
      this.loading = true;
      this.selectedFiles = this.$refs.filee.files;

      //Upload other images
      if (this.selectedFiles !== undefined) {
        let formData = new FormData();
        for (let index = 0; index < this.selectedFiles.length; index++) {
          const element = this.selectedFiles[index];
          //console.log("elem", element);
          formData.append("file[" + index + "]", element);
        }

        axios
          .post(this.$store.state.upload, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((e) => {
            e.data.myresp.forEach((elem) => {
              //console.log(elem.path);
              axios
                .post(this.$store.state.domain + "/shoesImages", {
                  shoe_id: this.myObj.shoe_id,
                  imgURL: elem.path,
                })
                .then((res) => {
                  //console.log("image uploaded", res);
                  this.LoadImages(this.myObj.shoe_id);
                })
                .catch((err) => {
                  console.error("upload error", err);
                });
            });
          })
          .catch((error) => {
            //console.log("Server Error on saving: ", error);
          })
          .finally(() => {
            this.selectedFiles = undefined;
            this.spin = "";
            this.loading = false;
          });
      }
      //console.log(this.selectedFiles);
    },
    date: function (date) {
      return moment(date).format("MMMM Do YYYY, h:mm:ss a");
    },
    addCategory() {
      if (
        this.myObj.buttonURL.trim() == "" ||
        this.myObj.title.trim() == "" ||
        this.myObj.imageURL == "" ||
        this.myObj.bannerID == ""
      ) {
        this.$notify({
          verticalAlign: "bottom",
          horizontalAlign: "center",
          message: "Please fill the details properly!",
          type: "danger",
          icon: "fa fa-ban",
          timeout: 0,
        });
      } else {
        // console.log(this.myObj);
        if (this.myObj.banner_id == 0) {
          this.postCategory();
        } else {
          this.putCategory();
        }
      }
    },
    postCategory() {
      //Post Request
      this.saving = true;
      var url = this.$store.state.domain + "/banners";

      //console.log("url:", url);
      //console.log("data:", this.myObj);
      axios
        .post(url, this.myObj)
        .then((response) => {
          this.saving = false;
          // console.log(response);
          if (response.data.status === "error") {
            this.$notify({
              verticalAlign: "bottom",
              horizontalAlign: "center",
              message: "Request Error! <br />" + response.data.data,
              type: "danger",
              icon: "fa fa-ban",
              timeout: 0,
            });
          } else {
            this.modals.showModal = false;
            this.LoadData();
            this.$notify({
              verticalAlign: "bottom",
              horizontalAlign: "center",
              message: "Saved! <br /> New Banner added.",
              type: "success",
              icon: "fa fa-check",
              timeout: this.$store.state.timeout,
            });
          }
        })
        .catch(function (error) {
          this.saving = false;
          //console.log(error);
          this.$notify({
            verticalAlign: "bottom",
            horizontalAlign: "center",
            message:
              "Request Error! <br />Request cannot be processed at the moment.",
            type: "danger",
            icon: "fa fa-ban",
            timeout: 0,
          });
        });

      ////console.log(fn);
      this.optionName = "Add Banner";
      this.modals.showModal = false;
    },
    putCategory() {
      //Put Request
      this.saving = true;
      var url = this.$store.state.domain + "/banners/" + this.myObj.banner_id;

      //console.log(this.myObj);
      axios
        .put(url, this.myObj)
        .then((response) => {
          // console.log(response);
          this.saving = false;
          if (response.data.status === "error") {
            this.$notify({
              verticalAlign: "bottom",
              horizontalAlign: "center",
              message: "Request Error! <br />" + response.data.data,
              type: "danger",
              icon: "fa fa-ban",
              timeout: 0,
            });
          } else {
            this.modals.showModal = false;
            this.LoadData();
            this.$notify({
              verticalAlign: "bottom",
              horizontalAlign: "center",
              message: "Saved! <br /> Banner updated.",
              type: "success",
              icon: "fa fa-check",
              timeout: this.$store.state.timeout,
            });
          }
        })
        .catch(function (error) {
          //console.log(error);
          this.saving = false;
          this.$notify({
            verticalAlign: "bottom",
            horizontalAlign: "center",
            message:
              "Request Error! <br />Request cannot be processed at the moment.",
            type: "danger",
            icon: "fa fa-ban",
            timeout: 0,
          });
        });

      //console.log("updated...");
      this.optionName = "Add Banner";
      this.modals.showModal = false;
    },
    UpdateCover() {
      //Put Request
      var url = this.$store.state.domain + "/shoes/" + this.myObj.shoe_id;
      if (this.myObj.release_date !== "") {
        var dts = this.myObj.release_date.split("-");
        this.myObj.release_date = dts[0] + "-" + dts[1] + "-" + dts[2];
      } else {
        this.myObj.release_date = null;
      }

      //console.log("url:", url);
      //console.log(this.myObj);
      axios
        .put(url, this.myObj)
        .then((response) => {
          //console.log(response);
          this.cover = this.myObj.cover_image;
        })
        .catch(function (error) {});
    },
    GetError() {
      return this.nameError;
      return this.prefixError;
    },

    editRecord(index, row) {
      axios
        .get(this.$store.state.domain + "/banners/" + row.banner_id)
        .then((res) => {
          // console.log("Get", res);
          this.eIndex = index;
          this.saving = false;
          this.optionName = "Edit";
          this.modals.showModal = true;
          this.sign = "far fa-edit";
          row = res.data;

          this.myObj.banner_id = row.banner_id;
          this.myObj.buttonURL = row.buttonURL;
          this.myObj.imageURL = row.imageURL;
          this.cover = row.imageURL;
          this.myObj.bannerID = row.bannerID;
          this.myObj.title = row.title;
        });
    },
    handleDelete(row) {
      swal({
        title: "Are you sure?",
        text: "You want to delete this banner?",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          axios
            .delete(this.$store.state.domain + "/banners/" + row.banner_id)
            .then((res) => {
              //console.log(res);
              this.deleteRow(row);
              this.$notify({
                verticalalign: "bottom",
                horizontalalign: "center",
                message: "Removed",
                type: "danger",
                icon: "fa fa-check",
                timeout: this.$store.state.timeout,
              });
            });
        }
      });
    },
    deleteRow(row) {
      let indexToDelete = this.tableData.findIndex(
        (tableRow) => tableRow.banner_id === row.banner_id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },
  },
};
</script>

<style>
.no-border-card .card-footer {
  border-top: 0;
}
</style>
